import { TokenInactivationSummary } from '../../../type/token';
import { HTTPTokenSummary } from '../http-token-response';

export function parseTokenInactivationSummary(httpToken: HTTPTokenSummary): TokenInactivationSummary {
	return {
		tokenType: httpToken.token_type,
		count: httpToken.count
	};
}
